import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import api from "../services/api"; // Adjust path as needed
import { pointTypeKeys } from "../utils/photoUtils"; // Adjust path as needed

export const usePointConfigurations = () => {
  const [pointConfigurations, setPointConfigurations] = useState({});
  const [isLoadingConfig, setIsLoadingConfig] = useState(true);
  const [configError, setConfigError] = useState(null);

  useEffect(() => {
    let isMounted = true; // Flag to prevent state updates on unmounted component
    const fetchPointConfigurations = async () => {
      setIsLoadingConfig(true);
      setConfigError(null);
      try {
        const token = localStorage.getItem("access_token");
        if (!token) {
          throw new Error("Authentication token not found. Please log in.");
        }

        const response = await api.get("/prices", {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("camera response : ", response.data);
        const data = response.data;
        const transformedConfigs = data.reduce((acc, item) => {
          const customKey = pointTypeKeys[item.type];
          if (customKey) {
            acc[customKey] = {
              type: item.type,
              fields: item.champ.reduce((fieldAcc, field) => {
                fieldAcc[field.titre] = field.choix.map(
                  (choice) => choice.titre
                );
                return fieldAcc;
              }, {}),
            };
          } else {
            console.warn(`No key mapping found for point type: ${item.type}`);
          }
          return acc;
        }, {});

        if (isMounted) {
          setPointConfigurations(transformedConfigs);
        }
      } catch (err) {
        console.error("Error fetching point configurations:", err);
        let errorMsg = "Failed to load configurations. Please try again later.";
        if (err.message === "Authentication token not found. Please log in.") {
          errorMsg = err.message;
        } else if (err.response && err.response.status === 401) {
          errorMsg = "Authentication failed. Please log in again.";
        }
        if (isMounted) {
          setConfigError(errorMsg);
          toast.error(errorMsg);
        }
      } finally {
        if (isMounted) {
          setIsLoadingConfig(false);
        }
      }
    };

    fetchPointConfigurations();

    // Cleanup function to set isMounted to false when the component unmounts
    return () => {
      isMounted = false;
    };
  }, []); // Runs once on mount

  return { pointConfigurations, isLoadingConfig, configError };
};
